<template>
  <div
    :style="styles"
    class="link-list"
    @click="pushGTM"
  >
    <p
      :style="titleStyles"
      class="link-list__title"
    >
      <slot name="title" />
    </p>
    <ul
      class="link-list__list"
    >
      <slot name="links" />
    </ul>
  </div>
</template>

<script>
import { computed } from 'vue'
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'link-list',
  props: {
    titleColor: {
      type: String,
      default: '#233037',
    },
    titleAlign: {
      type: String,
      default: 'left'
    }
  },
  setup(props) {
    const styles = computed(() => ({
      color: props.titleColor
    }))

    const titleStyles = computed(() => ({
      textAlign: props.titleAlign
    }))

    const pushGTM = (event) => {
      const li = event.target.closest('li')
      const target = li ? li.querySelector('a') : null

      if (target) {
        window.dataLayer.push({
          event: 'click',
          section: 'links-rápidos',
          label: target?.innerText || target?.getAttribute('aria-label') || '',
          outbound: isOutbound(target) || false
        })
      }
    }

    return {
      styles,
      titleStyles,
      pushGTM
    }
  }
}
</script>

<style lang="scss" scoped>
.link-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: -webkit-fill-available;

  &__title {
    @include font-telegraf(400);
    line-height: 140%;
    font-size: 1.25rem;
    @include textAlign();
  }

  &__list {
    padding-inline-start: 0;
  }
}

</style>
